/**
 * Build-time stub for POKER-ONLY route modules in an Echidna build.
 *
 * Phase 3 of docs/ECHIDNA_DECOUPLING_BRIEF.md: dist/ is packaged wholesale
 * into the native .aab/.ipa, so every chunk Rollup emits ships — the Echidna
 * app was carrying PokerBlitz's 224K `page` chunk and 344K `Admin` chunk it
 * could never render. The `echidna:prune-poker-modules` resolver in
 * vite.config.ts redirects those modules here when VITE_VARIANT_KEY=echidna,
 * so their graphs are never emitted. Same pattern as the Firebase sdkStub
 * alias that keeps Echidna's backend out of the PokerBlitz binary — in the
 * other direction.
 *
 * Every export renders nothing. None of them is REACHABLE in an Echidna
 * build (App.tsx and game-main.tsx take the IS_ECHIDNA branch before any of
 * these mount); the throw is a tripwire so that if a future refactor makes
 * one reachable, the failure is loud and names the bug instead of rendering
 * a blank poker page inside the word game.
 */
function stub(name: string): () => never {
  return () => {
    throw new Error(
      `[echidna build] poker-only module "${name}" was rendered — ` +
        `this route should be unreachable in an Echidna build; see ` +
        `echidna:prune-poker-modules in vite.config.ts`,
    );
  };
}

const Home = stub('app/page (Home)');
export default Home;
export const Admin = stub('admin/Admin');
export const LandingPage = stub('landing/LandingPage');
export const LabsPage = stub('labs/LabsPage');
export const BattlePage = stub('battle/BattlePage');
